module.exports = __webpack_public_path__ + "images/50ec3c08473eaeaabe6813896fb6b028.png";